module.exports = __webpack_public_path__ + "img/PAUSE.fbc6e1c5.svg";